<template>
  <div class="lds-ring" :class="{ small: small, white: white }">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars.less";

.lds-ring {
  display: inline-block;
  position: relative;
  width: @h8;
  height: @h8;
  &.small {
    width: @h4;
    height: @h4;
    div {
      width: @h2;
      height: @h2;
      margin: @h1;
    }
  }
  &.white {
    div {
      border: 3px solid #fff;
      border-color: #fff transparent transparent transparent;
    }
  }
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: @h4;
    height: @h4;
    margin: @h2;
    border: 3px solid #000;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #000 transparent transparent transparent;
    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
